import React from 'react';

function ButtonOutline({clases, color, type, icono, icono2, id, accion, texto, estadoForm, loading, disabled}){
    
    return(
        <button 
            id={id} 
            className={ estadoForm === "readonly" || estadoForm === "disabled" ? ` noDisplay btn btn-flat mr-1 btn-outline-${color} ${clases}` :  `btn btn-flat mr-1 btn-outline-${color} ${clases}` } 
            type={type} 
            onClick={accion !== null ? ()=> accion(): null  } 
            disabled={ loading ? true : disabled } 
        >
            { icono !== "" 
                ?
                <i className={"ml-1 "+icono  }></i>
                :
                null
            }
            { icono2 !== "" 
                ?
                <i className={"ml-1 "+icono2 }></i>
                :
                null
            }
            {texto}
        </button>
    )
}

export default ButtonOutline;